"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./AddressGrid.less");

require("react-select/dist/react-select.css");

var _underscore = _interopRequireDefault(require("underscore"));

var _countries = _interopRequireDefault(require("../../assets/countries"));

var _AddressAutoComplete = _interopRequireDefault(require("./AddressAutoComplete"));

var _AddressValidationMessage = _interopRequireDefault(require("./AddressValidationMessage"));

var _AddressValidation = require("../../utils/AddressValidation");

var _InputField = _interopRequireDefault(require("../InputGrid/InputField"));

var _InputRow = _interopRequireDefault(require("../InputGrid/InputRow"));

var _InputGrid = _interopRequireDefault(require("../InputGrid/InputGrid"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var REQUIRED_ADDRESS_VALIDATION_FIELDS = ['address1', 'city', 'state'];
var UNITED_STATES = 'US';

var AddressGrid = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AddressGrid, _React$Component);

  var _super = _createSuper(AddressGrid);

  function AddressGrid(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AddressGrid);
    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAddressSuggestionSelection = _this.handleAddressSuggestionSelection.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateAddress = _this.validateAddress.bind((0, _assertThisInitialized2.default)(_this));
    _this.autocompleteAddress = _underscore.default.debounce(_this.autocompleteAddress.bind((0, _assertThisInitialized2.default)(_this)), 300, true); // Pick props for phone, address1, etc... Pick found props to remove null values.

    _this.state = _underscore.default.pick(_underscore.default.pick(_this.props, 'phone', 'address1', 'address2', 'city', 'state', 'zip', 'country'), function (value) {
      return value !== null;
    });

    if (_underscore.default.filter(REQUIRED_ADDRESS_VALIDATION_FIELDS, function (key) {
      return !_underscore.default.isUndefined(_this.state[key]) && _this.state[key] !== '';
    }).length === REQUIRED_ADDRESS_VALIDATION_FIELDS.length) {
      _this.validateAddress();
    }

    return _this;
  }

  (0, _createClass2.default)(AddressGrid, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      // Pick props for phone, address1, etc... Pick found props to remove null values.
      var state = _underscore.default.pick(_underscore.default.pick(props, 'phone', 'address1', 'address2', 'city', 'state', 'zip', 'country'), function (value) {
        return value !== null;
      });

      if (!_underscore.default.isEmpty(state)) {
        this.setState(state);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(name, value) {
      var state = {}; // Normalize the change event so we always pass the name of field changing and its value

      if (name === 'state' && !value) {
        this.validateAddress();
      }

      if (value && value.target) {
        // value is an event object
        state[name] = value.target.value || '';
      } else if (value && value.value) {
        // value is coming from the <Select /> ... so its an object with a label and value
        state[name] = value.value || '';
      } else {
        state[name] = value || '';
      }

      if (this.props.onChange) {
        // Trigger the onChange handler given in props if we have it
        this.props.onChange(name, state[name]);
      } //Handle autocompletion of address when address1 gets changed


      if (this.state.country === 'US' && name === 'address1' && this.props.addressValidation.autocomplete && state[name].length >= 3) {
        this.autocompleteAddress(state[name]);
      }

      state.addressValid = undefined;
      this.setState(state);

      if (name === 'country' && value !== this.state.country) {
        // reset the state if changing the country
        this.handleChange('state', '');
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(name, e) {
      var _this2 = this;

      if (_underscore.default.filter(REQUIRED_ADDRESS_VALIDATION_FIELDS, function (key) {
        return !_underscore.default.isUndefined(_this2.state[key]) && _this2.state[key] !== '';
      }).length === REQUIRED_ADDRESS_VALIDATION_FIELDS.length) {
        this.validateAddress();
      }

      if (this.props.onBlur) {
        this.props.onBlur({
          target: _objectSpread({
            name: name
          }, e.target)
        });
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(name, e) {
      if (name !== 'address1') {
        this.setState({
          addressAutoComplete: []
        });
      }

      if (this.props.onFocus) {
        this.props.onFocus({
          target: _objectSpread({
            name: name
          }, e.target)
        });
      }
    }
  }, {
    key: "autocompleteAddress",
    value: function autocompleteAddress(address1) {
      var _this3 = this;

      var promise = this.props.addressValidation.autocomplete((0, _AddressValidation.convertAddress)(_objectSpread({
        address1: address1
      }, _underscore.default.pick(this.state, 'address2', 'city', 'state', 'zip'))));
      console.debug('Received autocomplete promise: ', promise);
      promise.then(function (options) {
        console.debug('Received autocomplete response: ', options);

        if (_underscore.default.isArray(options)) {
          _this3.setState({
            addressAutoComplete: options
          });
        }
      });
    }
  }, {
    key: "handleAddressSuggestionSelection",
    value: function handleAddressSuggestionSelection(option) {
      var _this4 = this;

      console.debug('update form with new address', option);

      var state = _objectSpread({
        addressAutoComplete: []
      }, _underscore.default.pick(option, 'address1', 'city', 'zip'));

      if (!_underscore.default.isUndefined(option.secondary)) {
        state.address2 = option.secondary;
      } else if (!_underscore.default.isUndefined(option.address2)) {
        state.address2 = option.address2;
      } else {
        state.address2 = '';
      }

      if (!_underscore.default.isUndefined(option.zip)) {
        state.zip = option.zip;
      }

      if (!_underscore.default.isUndefined(option.postCode)) {
        state.zip = option.postCode;
      }

      var country = _underscore.default.findWhere(_countries.default, {
        value: this.state.country
      }) || {
        provinces: []
      };

      if (!_underscore.default.isUndefined(option.state)) {
        var stateObj = _underscore.default.find(country.provinces, function (province) {
          return province.value === option.state || province.label.toLowerCase() === option.state.toLowerCase();
        });

        if (stateObj) {
          state.state = stateObj.value;
        }
      }

      state.addressValid = undefined;
      this.setState(state, function () {
        return _this4.validateAddress();
      });
    }
  }, {
    key: "validateAddress",
    value: function validateAddress() {
      var _this5 = this;

      var address = _underscore.default.pick(this.state, 'address1', 'address2', 'city', 'state', 'zip');

      if (this.props.addressValidation.validate && _underscore.default.isUndefined(this.state.addressValid) && this.state.country === 'US') {
        //Validate address if all required address fields are entered.
        this.props.addressValidation.validate((0, _AddressValidation.convertAddress)(_underscore.default.pick(this.state, 'address1', 'address2', 'city', 'state', 'zip', 'country'))).then(function (_ref) {
          var valid = _ref.valid,
              _ref$candidates = _ref.candidates,
              candidates = _ref$candidates === void 0 ? [] : _ref$candidates;
          console.debug('Address validation responded with:', valid, candidates);

          if (!_underscore.default.isUndefined(valid)) {
            if (valid && candidates && candidates.length === 1 && !_underscore.default.isEqual(_underscore.default.pick(candidates[0], 'address1', 'address2', 'city', 'state', 'postCode'), (0, _AddressValidation.convertAddress)(address))) {
              _this5.handleAddressSuggestionSelection(candidates[0]);
            } else {
              _this5.setState({
                addressValid: valid,
                candidates: candidates
              }, function () {
                if (_this5.props.onChange) {
                  _this5.props.onChange(address);
                }
              });
            }
          }
        });
      } else if (this.props.onChange) {
        this.props.onChange(address);
      }
    }
  }, {
    key: "getColClass",
    value: function getColClass(fieldCountInRow) {
      return 'col-md-' + 12 / (fieldCountInRow ? fieldCountInRow : 1);
    }
  }, {
    key: "getCountrySelect",
    value: function getCountrySelect(fieldCountInRow, controlProps, validationProps) {
      return /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({
        name: "country",
        label: "Country",
        value: this.state.country,
        values: _countries.default
      }, controlProps, {
        className: "no-padding country-select col-sm-12 ".concat(this.getColClass(fieldCountInRow)),
        required: _underscore.default.contains(this.props.requiredFields, 'country'),
        onChange: _underscore.default.partial(this.handleChange, 'country'),
        onBlur: _underscore.default.partial(this.handleBlur, 'country'),
        onFocus: _underscore.default.partial(this.handleFocus, 'country')
      }, validationProps));
    }
  }, {
    key: "getStateSelect",
    value: function getStateSelect(lastRowCount, controlProps) {
      var formData = this.state;
      var stateProps = {};
      var country = _underscore.default.findWhere(_countries.default, {
        value: formData.country
      }) || {
        provinces: []
      };
      var stateLabel = formData.country === UNITED_STATES ? 'State' : 'Province'; // If we have no provinces to display, allow the user to input a custom value and always have it valid

      if (country.provinces.length > 0) {
        stateProps.values = country.provinces || [];
        stateProps.noResultsText = false;
      } else {
        stateProps.type = 'text';
      }

      stateProps.valid = this.props.isValid('state');
      return /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({
        name: "state",
        value: formData.state,
        label: stateLabel
      }, controlProps, stateProps, {
        className: "state col-sm-12 ".concat(this.getColClass(lastRowCount)),
        required: _underscore.default.contains(this.props.requiredFields, 'state'),
        onChange: _underscore.default.partial(this.handleChange, 'state'),
        onBlur: _underscore.default.partial(this.handleBlur, 'state'),
        onFocus: _underscore.default.partial(this.handleFocus, 'state'),
        trim: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var formData = this.state;

      var controlProps = _underscore.default.omit(this.props, 'phone', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'collectPhone', 'onChange', 'onBlur', 'onFocus', 'isValid', 'addressValidation');

      var validationProps = function validationProps(fieldname) {
        return {
          valid: _this6.props.isValid(fieldname)
        };
      };

      var topLineFields = null;
      var lastRowCount = 3;

      if (this.props.collectPhone) {
        lastRowCount = 2;
        topLineFields = /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, this.getCountrySelect(2, controlProps, validationProps('country')), /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({
          type: "text",
          name: "phone",
          value: formData.phone,
          label: "Phone Number"
        }, controlProps, {
          required: _underscore.default.contains(this.props.requiredFields, 'phone'),
          className: "phone col-sm-12 no-padding-right ".concat(this.getColClass(2)),
          onChange: _underscore.default.partial(this.handleChange, 'phone'),
          onBlur: _underscore.default.partial(this.handleBlur, 'phone'),
          onFocus: _underscore.default.partial(this.handleFocus, 'phone'),
          trim: true
        }, validationProps('phone'))));
      }

      var addressValidateMessage = null;

      if (!_underscore.default.isUndefined(this.state.addressValid)) {
        addressValidateMessage = /*#__PURE__*/_react.default.createElement(_AddressValidationMessage.default, {
          valid: this.state.addressValid,
          candidates: this.state.candidates || [],
          onSelect: function onSelect(candidate) {
            return _this6.handleAddressSuggestionSelection(candidate);
          }
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "address-grid"
      }, /*#__PURE__*/_react.default.createElement("div", null, topLineFields, /*#__PURE__*/_react.default.createElement(_InputGrid.default, null, /*#__PURE__*/_react.default.createElement(_InputRow.default, null, /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({
        type: "text",
        name: "address1",
        value: formData.address1,
        label: "Address Line 1"
      }, controlProps, {
        className: 'address-1 col-sm-12',
        required: _underscore.default.contains(this.props.requiredFields, 'address1'),
        autoComplete: "off",
        onChange: _underscore.default.partial(this.handleChange, 'address1'),
        onBlur: _underscore.default.partial(this.handleBlur, 'address1'),
        onFocus: _underscore.default.partial(this.handleFocus, 'address1'),
        trim: true
      }, validationProps('address1')), /*#__PURE__*/_react.default.createElement(_AddressAutoComplete.default, {
        candidates: this.state.addressAutoComplete || [],
        hideOnSelect: false,
        onSelect: function onSelect(option) {
          return _this6.handleAddressSuggestionSelection(option);
        }
      }))), /*#__PURE__*/_react.default.createElement(_InputRow.default, null, /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({
        type: "text",
        name: "address2",
        value: formData.address2,
        label: "Address Line 2 (APT# etc.)"
      }, controlProps, {
        className: 'address-2 col-md-6 col-sm-12',
        onChange: _underscore.default.partial(this.handleChange, 'address2'),
        onBlur: _underscore.default.partial(this.handleBlur, 'address2'),
        onFocus: _underscore.default.partial(this.handleFocus, 'address2'),
        trim: true
      }, validationProps('address2'))), /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({
        type: "text",
        name: "city",
        value: formData.city,
        label: "City"
      }, controlProps, {
        className: 'city col-md-6 col-xs-12',
        required: _underscore.default.contains(this.props.requiredFields, 'city'),
        onChange: _underscore.default.partial(this.handleChange, 'city'),
        onBlur: _underscore.default.partial(this.handleBlur, 'city'),
        onFocus: _underscore.default.partial(this.handleFocus, 'city'),
        trim: true
      }, validationProps('city')))), /*#__PURE__*/_react.default.createElement(_InputRow.default, null, this.getStateSelect(lastRowCount, controlProps), /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({
        type: "text",
        name: "zip",
        value: formData.zip,
        label: "Postal Code"
      }, controlProps, {
        className: "zip col-sm-12 ".concat(this.getColClass(lastRowCount)),
        required: _underscore.default.contains(this.props.requiredFields, 'zip'),
        onChange: _underscore.default.partial(this.handleChange, 'zip'),
        onBlur: _underscore.default.partial(this.handleBlur, 'zip'),
        onFocus: _underscore.default.partial(this.handleFocus, 'zip'),
        trim: true
      }, validationProps('zip'))), topLineFields ? null : this.getCountrySelect(lastRowCount, controlProps, validationProps('country'))))), addressValidateMessage);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        onChange: _propTypes.default.func,
        collectPhone: _propTypes.default.bool,
        phone: _propTypes.default.string,
        address1: _propTypes.default.string,
        address2: _propTypes.default.string,
        city: _propTypes.default.string,
        state: _propTypes.default.string,
        zip: _propTypes.default.string,
        country: _propTypes.default.string,
        isValid: _propTypes.default.func,
        requiredFields: _propTypes.default.array,
        addressValidation: _propTypes.default.shape({
          autocomplete: _propTypes.default.func,
          validate: _propTypes.default.func
        })
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        collectPhone: false,
        labelAsPlaceHolder: true,
        phone: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: 'US',
        requiredFields: ['country', 'phone', 'address1', 'state', 'city', 'zip'],
        isValid: function isValid() {},
        addressValidation: {}
      };
    }
  }]);
  return AddressGrid;
}(_react.default.Component);

exports.default = AddressGrid;